import { presentationSkillsModule } from './modules/presentation-skills';
import { technicalWritingModule } from './modules/technical-writing';
import { meetingFacilitationModule } from './modules/meeting-facilitation';
import { crossTeamCollaborationModule } from './modules/cross-team-collaboration';

export const TECHNICAL_COMMUNICATION_COURSES = [
  {
    id: 'technical-communication',
    title: 'Technical Communication & Presentation Skills',
    description: 'Master essential communication skills for technical professionals in enterprise environments.',
    level: 'intermediate',
    totalDuration: '3 hours',
    image: '/api/placeholder/400/300',
    prerequisites: ['Professional work experience'],
    learningOutcomes: [
      'Present technical concepts clearly to diverse audiences',
      'Write effective technical documentation and reports',
      'Lead productive meetings and technical discussions',
      'Collaborate effectively across teams and departments'
    ],
    modules: [
      presentationSkillsModule,
      technicalWritingModule,
      meetingFacilitationModule,
      crossTeamCollaborationModule
    ]
  }
];